<template>
  <div v-if="isTutor">
    <div v-if="isMessageLoading">
      <TutorMessage :isLoading="true" :phase="phase" :showIdentity="showIdentity" />
    </div>
    <div v-else>
      <TutorMessage
        :messageKey="messageKey"
        :dialogId="dialogId"
        :audioId="audioId"
        :autoPlay="autoPlay"
        :deferAudioFetch="deferAudioFetch"
        :segmentPhase="segmentPhase"
        :replay="replay"
        :msg="msg"
        :spokenText="spokenText"
        :seenAt="seenAt"
        :interaction="interaction"
        :interactionLive="interactionLive"
        :opener="opener"
        :showIdentity="showIdentity"
        @submit-interaction="$emit('submit-interaction', $event)"
      />
    </div>
  </div>
  <div v-else>
    <div v-if="isMessageLoading">
      <StudentMessage :isLoading="true" :phase="phase" />
    </div>
    <div v-else>
      <StudentMessage :audioId="audioId" :autoPlay="autoPlay" :msg="msg" />
    </div>
  </div>
</template>

<script>
import TutorMessage from "./TutorMessage.vue";
import StudentMessage from "./StudentMessage.vue";

export default {
  name: "ChatMessage",
  components: {
    TutorMessage,
    StudentMessage,
  },
  props: {
    messageKey: String,
    dialogId: String,
    msg: String,
    spokenText: String,
    speaker: String,
    audioId: String,
    seenAt: Number,
    isMessageLoading: { type: Boolean, default: false },
    phase: { type: String, default: "thinking" },
    autoPlay: { type: Boolean, default: false },
    // Both describe segmented reply delivery and mean nothing to a student
    // message, so only the tutor branch below forwards them.
    deferAudioFetch: { type: Boolean, default: false },
    segmentPhase: { type: String, default: null },
    // The tutor message's replay object from ChatScreen (the speed chip's
    // switch and, later, the phrase-replay fields). Forwarded as the same
    // object, never copied, because the chat patches it in place.
    replay: { type: Object, default: null },
    interaction: Object,
    interactionLive: { type: Boolean, default: false },
    // Present only on a pre-authored opener; forwarded straight to
    // TutorMessage, which renders its native-language help.
    opener: Object,
    // False when the preceding message is also Arti's, so consecutive tutor
    // messages group under one identity row.
    showIdentity: { type: Boolean, default: true },
  },
  emits: ["submit-interaction"],
  computed: {
    // Must be computed, not a one-time data() value: the student's transcript
    // reuses the tutor "listening" loader's v-for key, so Vue patches this same
    // instance in place and only the speaker prop changes. A frozen isTutor
    // would leave the learner's words rendering through the tutor branch.
    isTutor() {
      return this.speaker === "tutor";
    },
  },
};
</script>

<style></style>
